import { createSelector } from 'reselect';
import { labDetailsDownloadDataSelector, labDetailsDownloadingSelector } from './lab/selectors';
import {
  microbiologyDetailsDownloadDataSelector,
  microbiologyDetailsDownloadingSelector
} from './microbiology/selectors';
import {
  imagingDetailsDownloadDataSelector,
  imagingDetailsDownloadingSelector
} from './imaging/selectors';
import {
  pathologyDetailsDownloadDataSelector,
  pathologyDetailsDownloadingSelector
} from './pathology/selectors';
import { TestResultCategory } from './types';
import { testResultDetailsDataSelector } from './selectors.common';

/**
 * Download Selectors
 */

export const downloadingTestResultsSelector = createSelector(
  [
    labDetailsDownloadingSelector,
    microbiologyDetailsDownloadingSelector,
    imagingDetailsDownloadingSelector,
    pathologyDetailsDownloadingSelector
  ],
  (isDownloadingLab, isDownloadingMicrobiology, isDownloadingImaging, isDownloadingPathology) =>
    isDownloadingLab || isDownloadingMicrobiology || isDownloadingImaging || isDownloadingPathology
);

export const downloadTestResultsErrorSelector = createSelector(
  [
    testResultDetailsDataSelector,
    labDetailsDownloadDataSelector,
    microbiologyDetailsDownloadDataSelector,
    imagingDetailsDownloadDataSelector,
    pathologyDetailsDownloadDataSelector
  ],
  (detail, labData, microbiologyData, imagingData, pathologyData) => {
    if (detail?.content) {
      let category;
      let eventId;
      if (Array.isArray(detail?.content?.results)) {
        // Labs
        category = detail?.content?.results[0]?.category;
        eventId = detail?.content?.results[0]?.eventId;
      } else {
        category = detail?.content?.category;
        eventId = detail?.content?.eventId;
      }

      if (category === TestResultCategory.LAB) {
        return labData[eventId] === 'fail';
      }

      if (category === TestResultCategory.IMAGING) {
        return imagingData[eventId] === 'fail';
      }

      if (category === TestResultCategory.PATHOLOGY) {
        return pathologyData[eventId] === 'fail';
      }

      if (category === TestResultCategory.MICROBIOLOGY) {
        return microbiologyData[eventId] === 'fail';
      }
    }

    return false;
  }
);

export * from './selectors.common';
